import { render, staticRenderFns } from "./IconEmail.vue?vue&type=template&id=1700db74&"
import script from "./IconEmail.vue?vue&type=script&lang=js&"
export * from "./IconEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1700db74')) {
      api.createRecord('1700db74', component.options)
    } else {
      api.reload('1700db74', component.options)
    }
    module.hot.accept("./IconEmail.vue?vue&type=template&id=1700db74&", function () {
      api.rerender('1700db74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconEmail.vue"
export default component.exports